module.exports = __webpack_public_path__ + "img/Weapon_238.f5cfa8a8.png";